/* Packages */
import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';

/* Hooks */
import useValidation from "conversie-flow-bundle/assets/js/components/flow/hooks/useValidation";

/* React Bootstrap Tooltip */
import {Tooltip} from "react-bootstrap";
import {OverlayTrigger} from "react-bootstrap";

/* Symbols */
import toolTip from 'symbols/tooltip.svg';

/* Atoms */
import { Icon } from "js/components/atoms";

export default function ConversionFlowFieldChoiceExtended(props) {
    const { colClassName, field, inputType, path, id, updateChoice } = props;
    const { type, label, choices, required, disabled, placeholder = null, value, name, config } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    return (
        <div className={`${colClassName}`}>
            <Form.Group className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <div className="form-label-tooltip">
                        <Form.Label dangerouslySetInnerHTML={{ __html: label }} />

                        {config?.tooltip && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip className="mb-n2">
                                        {config?.tooltip}
                                    </Tooltip>
                                }
                            >
                                <div className="d-flex btn--tooltip">
                                    <Icon
                                        theme=""
                                        size={20}
                                        url={toolTip}
                                    />
                                </div>
                            </OverlayTrigger>
                        )}
                    </div>
                )}
                <div className="choices-container">
                    {choices?.map((choice, choiceIndex) => {
                        return (
                            <Form.Check
                                key={choice.key}
                                className={`custom-control custom-${inputType} ${error ? 'is-error' : ''}`}
                                type={inputType}
                                id={`${id}.choices.${choiceIndex}-${choice.key}`}
                            >
                                <Form.Check.Input
                                    type={inputType}
                                    className="custom-control-input"
                                    name={id}
                                    value={choice.key}
                                    {...{
                                        required,
                                        disabled,
                                        placeholder,
                                    }}
                                    checked={value?.includes(choice.key)}
                                    onChange={(e) => {
                                        updateChoice(choice, e.target.checked, () => {
                                            trigger(path);
                                        });
                                    }}
                                />
                                <Form.Check.Label className="custom-control-label" dangerouslySetInnerHTML={{ __html: choice.label }} />
                            </Form.Check>
                        );
                    })}
                </div>
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
